// Usage tracking that is the same on every screen: a page_view per route (tabs, settings, guide, help…)
// and the names to hide in tap labels. Events themselves live in lib/analytics.ts.
import { useEffect } from 'react';
import { useLocation } from 'react-router';
import { pageView, setMaskWords } from '@/lib/analytics';
import { useSession } from '@/lib/session';

export function Usage() {
  const s = useSession();
  const loc = useLocation();

  useEffect(() => {
    if (s.status === 'ready' || s.status === 'no-access') pageView(loc.pathname);
  }, [loc.pathname, s.status]);

  useEffect(() => {
    const names = (s.families ?? []).flatMap((f) => [...f.babies.map((b) => b.name), ...f.members.map((m) => m.name)]);
    setMaskWords([...names, s.me?.name]);
  }, [s.families, s.me?.name]);

  return null;
}
